function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4b4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Lager_2",
  "data-name": "Lager 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M70.14,161.29a1.79,1.79,0,0,1-.58-3.49l21.75-7.4a1.79,1.79,0,1,1,1.15,3.39l-21.75,7.4A1.63,1.63,0,0,1,70.14,161.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.39,157.21a1.79,1.79,0,0,1-.58-3.49l43.5-14.81a1.79,1.79,0,0,1,1.15,3.39L49,157.11A1.69,1.69,0,0,1,48.39,157.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.39,145.72a1.79,1.79,0,0,1-.58-3.48l43.5-14.82a1.79,1.79,0,1,1,1.15,3.39L49,145.63A2,2,0,0,1,48.39,145.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.39,134.23a1.79,1.79,0,0,1-.58-3.48l43.5-14.82a1.79,1.79,0,0,1,1.15,3.39L49,134.14A2,2,0,0,1,48.39,134.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M70.14,161.29a1.65,1.65,0,0,1-.58-.1L52.7,155.45a1.8,1.8,0,0,1-1.22-1.7V117.52a16.65,16.65,0,0,0-6.3-13,39.77,39.77,0,1,1,64.67-32h0a39.46,39.46,0,0,1-14.75,32,16.68,16.68,0,0,0-6.31,13v36.22a1.8,1.8,0,0,1-1.21,1.7l-16.87,5.74A1.59,1.59,0,0,1,70.14,161.29Zm-15.08-8.82,15.08,5.14,15.07-5.14V117.53a20.23,20.23,0,0,1,7.64-15.75,35.91,35.91,0,0,0,13.42-29.09h0a36.15,36.15,0,1,0-58.84,29.09,20.21,20.21,0,0,1,7.63,15.74ZM87,153.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M91,81.16a1.78,1.78,0,0,1-1.71-1.26l-2.56-8.21-7,8.79a1.79,1.79,0,0,1-2.86-.07L70.14,71l-6.7,9.39a1.78,1.78,0,0,1-2.85.07l-7-8.79L51,79.9a1.79,1.79,0,1,1-3.41-1.07l3.56-11.42a1.77,1.77,0,0,1,1.38-1.23,1.82,1.82,0,0,1,1.73.64L61.9,76.4l6.78-9.5a1.8,1.8,0,0,1,1.46-.75,1.77,1.77,0,0,1,1.45.75l6.78,9.5L86,66.82a1.79,1.79,0,0,1,3.11.59L92.7,78.83a1.8,1.8,0,0,1-1.18,2.25A2,2,0,0,1,91,81.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M70.14,18.86a1.79,1.79,0,0,1-1.79-1.79V1.79a1.79,1.79,0,1,1,3.58,0V17.07A1.79,1.79,0,0,1,70.14,18.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M103.39,29.67a1.8,1.8,0,0,1-1-.34,1.78,1.78,0,0,1-.39-2.5l9-12.37a1.79,1.79,0,0,1,2.9,2.11l-9,12.36A1.79,1.79,0,0,1,103.39,29.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M124,58a1.79,1.79,0,0,1-.55-3.49l14.53-4.73A1.79,1.79,0,0,1,139,53.15L124.5,57.87A1.76,1.76,0,0,1,124,58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.48,97.65a1.76,1.76,0,0,1-.55-.09L123.4,92.84a1.79,1.79,0,1,1,1.1-3.4L139,94.16a1.79,1.79,0,0,1-.56,3.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M36.88,29.67a1.8,1.8,0,0,1-1.45-.74l-9-12.36a1.79,1.79,0,0,1,2.9-2.11l9,12.37a1.79,1.79,0,0,1-1.45,2.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.33,58a1.82,1.82,0,0,1-.56-.09L1.24,53.15a1.79,1.79,0,0,1,1.1-3.41l14.54,4.73A1.79,1.79,0,0,1,16.33,58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1.79,97.65a1.79,1.79,0,0,1-.55-3.49l14.53-4.72a1.79,1.79,0,1,1,1.11,3.4L2.34,97.56A1.76,1.76,0,0,1,1.79,97.65Z"
})));

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.27 161.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.7c5f208c.svg";
export { ForwardRef as ReactComponent };